(function() {
    'use strict';
    angular
        .module('verificadocumentoApp')
        .factory('CertificadoDeEstudios', CertificadoDeEstudios);

    CertificadoDeEstudios.$inject = ['$resource'];

    function CertificadoDeEstudios ($resource) {
        var resourceUrl =  'public/certificadodeestudios/:folioControl';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dom = angular.fromJson(data.dom);
                    }
                    return data;
                }
            }
        });
    }
})();